// extracted by mini-css-extract-plugin
module.exports = {"two-factor-auth-container":"two-factor-auth_two-factor-auth-container__GzyS4","publisher-logo":"two-factor-auth_publisher-logo__2qJx8"};